import React, { useEffect } from 'react';
import SearchBar from '../searchBar/searchBar';
import { Link } from 'react-router5';
import {useTranslation} from "react-i18next";

const safeColor = (color) => {
  return color.replace(/[^a-zA-Z0-9()#]/g, "")
}

const LinkTags = ({ links }) => {
  return <span className="c-infos_links">
    {
      links
      .filter(l => l.type)
      .map(l => {
	const color = safeColor(l.poi_link_category.color);
	return <span style={{color: color, borderColor: color}}>{l.type}</span>
      })
    }
  </span>
}


function SetReseaux({contact, getRoute}){
  // type will not be there w/ we are listing contacts of themes (and not links)
  const {poi_contact, links} = contact;

  let contact_img;
  if(poi_contact.img === undefined || poi_contact.img === null){
    contact_img = <span className="c-contact_img-replace">
      {poi_contact.firstname[0].toUpperCase()}{poi_contact.lastname[0].toUpperCase()}
    </span>
  }else{
    contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={poi_contact.img} />
  }

  const [route_name, route_params] = getRoute(poi_contact);

  return (
    <Link routeName={route_name} routeOptions={{reload: true}} routeParams={route_params}>
      <div className={`c-entities reseaux ${poi_contact.id}`}>
        {contact_img}
        <div className="c-infos">
          <p>{poi_contact.firstname} {poi_contact.lastname}</p>
	  <LinkTags links={links} />
        </div>
      </div>
    </Link>
  )
}

function prepSearch(term) {
  return term.toUpperCase().replace('É','E');
}

function sortContact(contacts){
  // retrieve a list of links, take the first one
  return contacts.sort(function(a, b){
    var nameA = prepSearch(a.poi_contact.firstname);
    var nameB = prepSearch(b.poi_contact.firstname);
    return nameA.localeCompare(nameB);
  });
}

function filterContact(contacts, search) {
  if (search === "") return contacts;

  search = prepSearch(search);
  return contacts.filter(c => {
    return prepSearch(c.poi_contact.firstname + " " + c.poi_contact.lastname).includes(search);
  });
}

function groupLinksByContact(links_forward, links_backward) {
  const contact_link = links_forward.concat(links_backward)
      .filter(c => c.link_target_type === "poi_contact");

  var by_contact_id = {}
  contact_link.forEach(link => {
    var d = by_contact_id[link.poi_contact.id];
    if (!d) {
      by_contact_id[link.poi_contact.id] = {
	poi_contact: link.poi_contact,
	links: [link]
      }
    } else {
      d.links.push(link);
    }
  })

  return Object.keys(by_contact_id).map(x => by_contact_id[x]);
}


function Reseaux({links_forward, links_backward, getRoute}){
  const { t } = useTranslation();
  const [search, setSearch] = React.useState("");

  const links_by_contact = groupLinksByContact(links_forward, links_backward);
  const filtered_contacts = filterContact(links_by_contact, search);
  const contacts_with_links = sortContact(filtered_contacts);

  if (links_by_contact.length === 0) {
    return <p>{t('Aucun élément à afficher')}</p>
  }

  return <>
    <div className="c-container_search-bar">
      <SearchBar value={search} handleChange={(e) => setSearch(e.target.value)} />
    </div>
    {contacts_with_links.map(c => {
      return(
	<div className="c-contact_list-letter title" key={c.poi_contact.id}>
	   <SetReseaux contact={c} getRoute={getRoute}/>
	</div>
      )
    })}
  </>
}

export default Reseaux
